import React, { useContext } from "react";

import HistoryEventTimeAndScore from "@features/offer/desktop/event/info-header/live-event/HistoryEventTimeAndScore";
import { SportOfferContext } from "@gp/components";
import { EventOffer, SportOffer } from "@gp/offer";
import { observer } from "mobx-react";

import { AdditionalOfferLinkWrapper } from "./AdditionalOfferLinkWrapper";
import { EventTeamsInfo } from "./EventTeamsInfo";
import { HistoryEventCurrentStats } from "./live-event";

export const HistoryEventInfo = observer(function HistoryEventInfo(props: {
	event: EventOffer;
}) {
	const sport = useContext(SportOfferContext) as SportOffer;
	return (
		<>
			<AdditionalOfferLinkWrapper>
				<EventTeamsInfo event={props.event}>
					<HistoryEventTimeAndScore event={props.event} />
				</EventTeamsInfo>
			</AdditionalOfferLinkWrapper>

			<HistoryEventCurrentStats event={props.event} sport={sport} />
		</>
	);
});
